var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcWalletWalletConnect = function SvgIcWalletWalletConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_wallet_wallet_connect_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0v20h20V0Z",
    fill: "#3B99FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.993 7.41a5.667 5.667 0 0 1 8.014 0l.267.266c.11.11.11.29 0 .401l-.911.911a.142.142 0 0 1-.2 0l-.367-.366a3.954 3.954 0 0 0-5.592 0l-.392.392a.142.142 0 0 1-.2 0L5.7 8.103a.283.283 0 0 1 0-.4l.293-.293Zm9.899 1.884.81.811c.111.11.111.29 0 .401l-3.656 3.657c-.11.11-.29.11-.4 0l-2.596-2.596a.071.071 0 0 0-.1 0l-2.595 2.596c-.11.11-.29.11-.4 0l-3.658-3.657a.283.283 0 0 1 0-.4l.811-.812c.111-.11.29-.11.401 0l2.595 2.596a.071.071 0 0 0 .1 0L9.8 9.294c.11-.11.29-.11.4 0l2.596 2.596a.071.071 0 0 0 .1 0l2.595-2.596c.11-.11.29-.11.4 0Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_wallet_wallet_connect_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#fff"
  })))));
};
export default SvgIcWalletWalletConnect;